import { Typography as MuiTypography, styled } from '@material-ui/core';

import { COLORS } from 'theme/constants';

export const WidgetTitle = styled(MuiTypography)({
  paddingBottom: '12px',
  fontSize: '16px',
  fontWeight: 600,
  color: COLORS.cozmosPurple4,
});

export const ErrorText = styled(MuiTypography)({
  fontSize: '14px',
  color: COLORS.red,
});

export const NoteText = styled(MuiTypography)({
  fontSize: '14px',
  fontWeight: 600,
  color: COLORS.cozmosPurple4,
});
